import React from 'react';
import { StartLink } from './StartLink';

const STEPS = [
  ['Application review', 'We review your information and contact candidates selected to move forward.'],
  ['Interview', 'A conversation about your experience, availability, and the opportunity.'],
  ['Paid trial clean', 'A practical assessment in a small home, with about one hour expected and up to two hours planned.'],
  ['Hiring decision', 'We review the application, conversation, and assessment before making a decision.'],
];

export const HiringNext = () => (
  <section className="hiring-next" aria-labelledby="next-title" data-testid="hiring-next-section">
    <p className="section-label">AFTER YOU APPLY</p>
    <h2 id="next-title">Here’s what comes next.</h2>
    <div className="hiring-sequence">
      {STEPS.map(([title, body], i) => (
        <article key={title}>
          <span>{`0${i + 1}`}</span>
          <h3>{title}</h3>
          <p>{body}</p>
        </article>
      ))}
    </div>
    <div className="hiring-apply"><StartLink testId="hiring-next-apply" /></div>
    <p className="hiring-footnote">Selected candidates move forward to an offer and onboarding. Applying does not guarantee an interview or hire.</p>
  </section>
);
